import { render, staticRenderFns } from "./ourCorporate.vue?vue&type=template&id=62dfb9c1&scoped=true"
import script from "./ourCorporate.vue?vue&type=script&lang=js"
export * from "./ourCorporate.vue?vue&type=script&lang=js"
import style0 from "./ourCorporate.vue?vue&type=style&index=0&id=62dfb9c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dfb9c1",
  null
  
)

export default component.exports